import { useBuilderStore } from '../../store/builderStore';
import { cn } from '@printtat/ui';
import { VariantRow } from "../VariantRow";

export const ColorVariants = () => {
  const availableColors = useBuilderStore((s) => s.availableColors);
  const selectedColor = useBuilderStore((s) => s.selectedColor);
  const enabledColors = useBuilderStore((s) => s.enabledColors);
  const defaultColor = useBuilderStore((s) => s.defaultColor);
  const setSelectedColor = useBuilderStore((s) => s.setSelectedColor);
  const toggleColor = useBuilderStore((s) => s.toggleColor);
  const setDefaultColor = useBuilderStore((s) => s.setDefaultColor);

  if (availableColors.length === 0) return null;

  const enabledCount = enabledColors.length;

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-2.5 py-1.5">
        <span className="text-[11px] font-semibold text-[#1a1a1a] tracking-tight">Colors</span>
        <span className="text-[10px] text-[#aaa]">{enabledCount}/{availableColors.length}</span>
      </div>
      <div className="flex flex-col pb-1">
        {availableColors.map((color) => {
          const isEnabled = enabledColors.includes(color.name);
          const isSelected = selectedColor?.name === color.name;
          const isOutOfStock = !color.hasStock;
          const isDefault = defaultColor === color.name;

          return (
            <VariantRow
              key={color.name}
              isEnabled={isEnabled}
              isOutOfStock={isOutOfStock}
              isDefault={isDefault}
              onToggle={() => toggleColor(color.name)}
              onSetDefault={() => setDefaultColor(color.name)}
              className={isSelected && !isOutOfStock ? "bg-[#f5f5f5]" : undefined}
            >
              <button
                onClick={() => {
                  if (isOutOfStock) return;
                  if (isEnabled) setSelectedColor(color);
                }}
                disabled={isOutOfStock}
                className={cn(
                  "w-4 h-4 rounded-full border transition-all flex-shrink-0",
                  isSelected
                    ? "border-gray-900 ring-1.5 ring-gray-900/20"
                    : "border-gray-300",
                  !isOutOfStock && "cursor-pointer hover:border-gray-400",
                )}
                style={{ backgroundColor: color.hex }}
              />
              <span
                className={cn(
                  "flex-1 text-[10px] text-[#555] cursor-default select-none",
                  isOutOfStock && "line-through",
                )}
              >
                {color.name}
              </span>
            </VariantRow>
          );
        })}
      </div>
    </div>
  );
};
